export const ROLE = {
  ADMIN: "Admin",
  MEMBER: "Member"
};

export const STAR_CONFIG = {
  MAX_STAR: 5,
  STAR_POINTS: [
    23,
    2,
    14,
    17,
    0,
    19,
    10,
    34,
    7,
    50,
    23,
    43,
    38,
    50,
    36,
    34,
    46,
    19,
    31,
    17
  ]
};
